/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import {
	EulaAgreementSection,
	getHero,
	getSections,
	ResponsiveContainer,
	SectionContainer,
	sectionContentContainer,
	SizedLoadingProps,
} from "@cosmos/components";
import { CosmosPageAgreementFragment } from "@cosmos/hygraph-schema";
import { useEulaAcceptance } from "@cosmos/next-hooks";
import { ComponentType } from "react";

import { css, cx } from "@panda/css";
import { Stack } from "@panda/jsx";

export interface AgreementProps {
	pageData: CosmosPageAgreementFragment;
	locale: string;
	eulaContentBody: string;
	eulaContentTitle: string;
	version: number;
	alreadyAccepted: boolean;
	LoadingComponent?: ComponentType<SizedLoadingProps>;
}

export const Agreement = ({
	pageData,
	locale,
	eulaContentBody,
	eulaContentTitle,
	version,
	alreadyAccepted,
	LoadingComponent,
}: AgreementProps): React.JSX.Element => {
	const sectionLength = pageData?.refSections?.length || 0;

	return (
		<>
			{getHero(pageData?.hero)}
			{getSections(pageData?.refSections)}

			{sectionLength === 0 ? <div className={css({ w: "full", height: "eds.dimension.96" })} /> : null}

			<ResponsiveContainer>
				<SectionContainer
					className={cx(
						"eula-agreement-section",
						css({
							paddingBlockEnd: "eds.dimension.128",
							smDown: { paddingBlockEnd: "eds.dimension.40" },
						}),
					)}
					disablePaddingBlock={true}
				>
					<Stack
						gap="eds.dimension.32"
						className={cx(css({ alignItems: "center" }), sectionContentContainer({ wide: true, centered: false }))}
					>
						<EulaAgreementSection
							{...pageData}
							locale={locale}
							eulaContentBody={eulaContentBody}
							eulaContentTitle={eulaContentTitle}
							alreadyAccepted={alreadyAccepted}
							version={version}
							LoadingComponent={LoadingComponent}
							useEulaAcceptance={useEulaAcceptance}
						/>
					</Stack>
				</SectionContainer>
			</ResponsiveContainer>
		</>
	);
};
